import gql from "graphql-tag";

export const createShippingProfile = gql`
  mutation createShippingProfile(
    $shippingProfile: CreateShippingProfileInput!
  ) {
    createShippingProfile(shippingProfile: $shippingProfile) {
      id
    }
  }
`;

export const EditShippingProfile = gql`
  mutation EditShippingProfile($shippingProfile: EditShippingProfileInput!) {
    editShippingProfile(shippingProfile: $shippingProfile) {
      id
    }
  }
`;

export const DeleteShippingProfile = gql`
  mutation DeleteShippingProfile($id: String!) {
    deleteShippingProfile(id: $id)
  }
`;

export const createShippingZone = gql`
  mutation createShippingZone($shippingZone: CreateShippingZoneInput!) {
    createShippingZone(shippingZone: $shippingZone) {
      id
    }
  }
`;

export const editShippingZone = gql`
  mutation editShippingZone($shippingZone: EditShippingZoneInput!) {
    editShippingZone(shippingZone: $shippingZone) {
      id
    }
  }
`;

export const deleteShippingZone = gql`
  mutation deleteShippingZone($id: String!) {
    deleteShippingZone(id: $id)
  }
`;

export const createShippingRule = gql`
  mutation createShippingRule($shippingRule: CreateShippingRuleInput!) {
    createShippingRule(shippingRule: $shippingRule) {
      id
    }
  }
`;

export const editShippingRule = gql`
  mutation editShippingRule($shippingRule: EditShippingRuleInput!) {
    editShippingRule(shippingRule: $shippingRule) {
      id
    }
  }
`;

export const deleteShippingRule = gql`
  mutation deleteShippingRule($id: String!) {
    deleteShippingRule(id: $id)
  }
`;
